import CustomFormControl, {
  TCustomFormControlProps
} from '@Modules/core/components/form/CustomFormControl';
import React from 'react';
import { BankIDInputMeta } from '../../containers/forms/commonMeta';
import CustomBankIDInput from './CustomBankIDInput';

type Props = {
  register?: any,
  hasError: any,
} & Omit<TCustomFormControlProps, "children" | "isInvalid">;

const CustomFormBankIDInput: React.FC<Props> = ({
  labelStyle,
  register,
  isLoading,
  hasError,
  ...rest
}) => {
  return (
    <CustomFormControl
      {...rest}
      isInvalid={!!hasError}
      isLoading={isLoading}
      label={BankIDInputMeta.label}
      labelStyle={labelStyle}
    >
      <CustomBankIDInput register={register} hasError={hasError} />
    </CustomFormControl>
  );
};

export default CustomFormBankIDInput;
